/* eslint eqeqeq: 'off' */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';


// Displaying List of Tenants invoice details
export function GetTenantInvoiceDetails(data) { 
    return function (dispatch) {
        return APIutil.postData(url.post_Tenant_Invoice_Details,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response !== undefined && response.status == 200)
                dispatch(actionToStoreSuccess(response,types.GET_TENANT_INVOICE_DETAILS_SUCCESSFUL));
        }).catch(error => { throw error; })
    }
}

// Displaying List of Tenants After hours details
export function GetAfterHoursInvoiceData(id,from,to) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Tenant_By_ID + id + url.get_Tenant_AfterHours+'?startDate='+from+'&endDate='+to).then(response => {
            dispatch(global_error_handling(response)); 
           if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_TENANT_AFTERHOURS_DETAILS_SUCCESSFUL));
        }).catch(error => {
            throw error;
        })
    }
}

export function SaveAfterHourDetails(data,TenantID,from,to) {

    return function (dispatch) {
        return APIutil.editDataAPI(url.get_Tenant_By_ID + TenantID + url.get_Tenant_AfterHours,data).then(response => {
            dispatch(global_error_handling(response)); 
            if(response.status == 200)
            dispatch(GetAfterHoursInvoiceData(TenantID,from,to));
        }).catch(error => {
            throw error;
        })
    }
}


//Get Invoice Template
export function GetInvoiceTemplate() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.Invoice_Template).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined && response !== "")
                dispatch(actionToStoreSuccess(response,types.GET_INOVICE_TEMPLATE));
            else
            dispatch(actionToStoreSuccess(false,types.GET_INOVICE_TEMPLATE));
        }).catch(error => { throw error; })
    }
}

export function GetFacilityImage() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.Facility_background_image).then(response => {
            dispatch(global_error_handling(response)); 
            if(response != null && response != undefined && response !== "")
                dispatch(actionToStoreSuccess(response,types.GET_FACILITY_IMAGE));
            else
            dispatch(actionToStoreSuccess(false,types.GET_FACILITY_IMAGE));
        }).catch(error => { throw error; })
    }
}

export function PutInvoiceTemplate(data) {
    return function (dispatch) {
        return APIutil.editDataAPI(url.Invoice_Template,data).then(response => {
            dispatch(global_error_handling(response)); 
             if(response.status == 200)
             dispatch(GetInvoiceLogo());
             dispatch(GetInvoiceTemplate());
           //  dispatch(actionToStoreSuccess(true,types.POST_INOVICE_IMAGE));
        }).catch(error => {
            throw error;
        })
    }
}


//Get Invoice Template logo/ Image
export function GetInvoiceLogo() { 
    return function (dispatch) {
        return APIutil.getImage(url.Invoice_logo).then(response => {
            const fileReaderInstance = new FileReader();
            dispatch(global_error_handling(response)); 
            if(response !== undefined && response.status == 200 ){
                fileReaderInstance.readAsDataURL(response.data); 
                fileReaderInstance.onload = () => {
                   var base64data = fileReaderInstance.result;     
                  dispatch(actionToStoreSuccess(base64data,types.GET_INOVICE_LOGO));
                }
            }
        }).catch(error => { throw error; })
    }
}


export function GetFacilityBackgroundImage() { 
    return function (dispatch) {
        return APIutil.getImage(url.Facility_Image).then(response => {
            const fileReaderInstance = new FileReader();
            dispatch(global_error_handling(response)); 
            if(response !== undefined && response.status == 200 ){
                fileReaderInstance.readAsDataURL(response.data); 
                fileReaderInstance.onload = () => {
                   var base64data = fileReaderInstance.result;     
                  dispatch(actionToStoreSuccess(base64data,types.GET_FACILITY_BACKGROUND_IMAGE));
                }
            }
        }).catch(error => { throw error; })
    }
}

//Post Template logo/ Image
export function PostInvoiceLogo(imagefile) { 

    return function (dispatch) {
        return APIutil.postImage(url.Invoice_logo,imagefile).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }
}

export function PostFacilityLogo(imagefile){
    return function (dispatch) {
        return APIutil.postImage(url.Facility_logo,imagefile).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }  
}

export function PostFacilityBackgroundImage(imagefile){
    return function (dispatch) {
        return APIutil.postImage(url.Facility_background_image,imagefile).then(response => {
            dispatch(global_error_handling(response)); 
        }).catch(error => { throw error; })
    }   
}
// Restore Facility Background Image
export function RestoreFacilityBackgroundImage(RestoreImage){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.Restore_Facility_Image,RestoreImage).then(response => {
            
            dispatch(global_error_handling(response)); 
          
        }).catch(error => { throw error; })
    }
}
// Delete Facility/Invoice Logo
export function DeleteFacilityInvoiceLogo(DeleteImage){
    return function (dispatch) {
        return APIutil.deleteDataAPI(url.Delete_Facility_Logo,DeleteImage).then(response => {
            
            dispatch(global_error_handling(response)); 
          
        }).catch(error => { throw error; })
    }
}

// Displaying List of Tenants Generated invoices
export function GetTenantGeneratedInvoices() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_generated_invoice).then(response => {
            if(response != null && response != undefined && response.length > 0)
                dispatch(actionToStoreSuccess(response,types.GET_TENANT_GENERATED_INVOICES_SUCCESSFUL));
        }).catch(error => { throw error; })
    }
}

// Download files
export function DownloadSelectedInvoice(invoiceId,fileName,fileFormat) { 
    return function (dispatch) {
        return APIutil.getPDFDataAPI(url.get_generated_invoice+"/"+invoiceId).then(response => {

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                console.log("IE Browser");
                window.navigator.msSaveOrOpenBlob(new Blob([response]), fileName + fileFormat);
            }
            else {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + fileFormat);
            document.body.appendChild(link);
            link.click();
            }
                //dispatch(actionToStoreSuccess(response,types.DOWNLOAD_INVOICE_SUCCESSFUL));
        }).catch(error => { throw error; })
    }
}

//Delete Invoices
export function DeleteInvoices(Invoices_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.get_generated_invoice,Invoices_to_be_deleted).then(response => {
          if(response.status == 200)
               dispatch(GetTenantGeneratedInvoices());
        }).catch(error => {
            throw error;
        })
    }
}

//Post email and send it to all specified recipients
export function SendInvoiceEmail(data) { 

    return function (dispatch) {
        return APIutil.postData(url.send_invoice_email,data).then(response => {
            console.log(response);
        }).catch(error => { throw error; })
    }
}


export function GenerateInvoice(data) {
    return function (dispatch) {
        var fileName = '';
        return APIutil.postDataForPDF(url.Generate_Invoice, data).then(response => {
            if (response.hasOwnProperty('status') == true && response.status == 200) {
                fileName = response.headers['content-disposition'].split(";")[1].substring(10, response.headers['content-disposition'].split(";")[1].length)
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    console.log("IE Browser");
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName.replace(/"/g, ''));
                }
                else {
                    const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName.replace(/"/g, ''));
                    document.body.appendChild(link);
                    link.click();
                }
            }
        }).catch(error => { throw error; })
    }
}

export function GenerateExcelInvoice(data){
    return function (dispatch) {
        var fileName = '';
        return APIutil.postDataForPDF(url.Generate_Invoice_Excel,data).then(response => {
            if(response.hasOwnProperty('status') == true && response.status == 200){
            fileName = response.headers['content-disposition'].split(";")[1].substring(10,response.headers['content-disposition'].split(";")[1].length)
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName.replace(/"/g, ''));
            }
            else {
            const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace(/"/g, ''));
            document.body.appendChild(link);
            link.click();
            }
            }
        }).catch(error => { throw error; })
    }  
}

export function GenerateSummaryInvoice(data){
    return function (dispatch) {
        return APIutil.postDataForPDF(url.Generate_Summary_Invoice,data).then(response => {
            var fileName = response.headers['content-disposition'].split(";")[1].substring(10,response.headers['content-disposition'].split(";")[1].length)
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName.replace(/"/g, ''));
            }
            else {
            const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace(/"/g, ''));
            document.body.appendChild(link);
            link.click();
            }
        }).catch(error => { throw error; })
    } 
}

export function GenerateExcelSummaryInvoice(data){
    return function (dispatch) {
        return APIutil.postDataForPDF(url.Generate_Excel_Summary_Invoice,data).then(response => {
            var fileName = response.headers['content-disposition'].split(";")[1].substring(10,response.headers['content-disposition'].split(";")[1].length);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName.replace(/"/g, ''));
            }
            else {
            const url = decodeURIComponent(encodeURIComponent(window.URL.createObjectURL(new Blob([response.data]))));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace(/"/g, ''));
            document.body.appendChild(link);
            link.click();
            }
        }).catch(error => { throw error; })
    } 
}

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}